import { CustomAction } from "..";
import { AUTH_ACTION_TYPES } from "../actions-types";
import { AuthStatus, AuthType } from "../../types/auth";

export const actionSetAuthType = (data: AuthType): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_TYPE,
    data,
  };
};

export const actionSetAuthStatus = (data: AuthStatus): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_STATUS,
    data,
  };
};

export const actionSetAuthLoggedIn = (data: boolean): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_LOGGED_IN,
    data,
  };
};

export const actionSetAuthEmailBanDuration = (data: string): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_EMAIL_BAN_DURATION,
    data,
  };
};

export const actionSetAuthLoggingOut = (data: boolean): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_LOGGING_OUT,
    data,
  };
};

export const actionResetAuth = (): CustomAction => {
  return {
    type: AUTH_ACTION_TYPES.RESET_AUTH,
  };
};
